import { Component } from '@angular/core';
import { CellRenderer } from '@shared/interfaces/table/cell-renderer';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-default-to-cell',
  imports: [
    TranslatePipe
  ],
  templateUrl: './default-to-cell.component.html',
  styleUrl: './default-to-cell.component.css',
})
export class DefaultToCellComponent extends CellRenderer {
  // Component simply shows a set default value if no value is provided
}
